import React from "react";
import './togglebutton.scss';
interface Iprops {
    btnList?:any,
    selectedItem?:any,
    onClick?:any
}
const ToggleButton = (props:Iprops) => {
    return <div className="toggleButton">
        {
            props.btnList.map((item:any,index:number) => {
             return  <div onClick={() => props.onClick(item)} onKeyDown={() => {}} className={`${item === props.selectedItem? 'active': ''}`} key={item}>{item}</div> 
            })
        }
    </div>
}

export default ToggleButton;
